<template>
<!-- 确认订单信息 -->
  <div class="page">
    <div
      style="
        background-color: #0065b3;
        color: #fff;
        font-size: 16px;
        padding: 6px 20px;
        margin-bottom:20px;
      "
    >
      &nbsp;&nbsp;企业信息
    </div>
    <el-descriptions class="margin-top" :column="2" border>
      <el-descriptions-item
        label="营业执照"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >
      <!-- <el-link type="primary" :underline="false" :href="filePath">点击查看</el-link> -->
        <el-button type="text" style="padding: 0;" @click="see">点击查看</el-button>
      </el-descriptions-item>
      <el-descriptions-item
        label="社会统一信用代码"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.companyCode}}</el-descriptions-item>
      <el-descriptions-item
        label="企业名称"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.companyName}}</el-descriptions-item>
      <el-descriptions-item
        label="法人姓名"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.legalPerson}}</el-descriptions-item>
    </el-descriptions>
    <div
      style="
        background-color: #0065b3;
        color: #fff;
        font-size: 16px;
        padding: 6px 20px;
        margin:20px 0;
      "
    >
      &nbsp;&nbsp;项目信息
    </div>
    <el-descriptions class="margin-top" :column="2" border>
      <el-descriptions-item
        label="项目名称"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.projectName}}</el-descriptions-item>
      <el-descriptions-item
        label="保证金金额(元)"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.guaMoney}}</el-descriptions-item>
      <el-descriptions-item
        label="标段名称"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.projectCode}}</el-descriptions-item>
      <el-descriptions-item
        label="开标日期"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.bidBeginDate}}</el-descriptions-item>
      <el-descriptions-item
        label="被保险人"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.profitsPerson}}</el-descriptions-item>
      <el-descriptions-item
        label="投标有效期"
        :labelStyle="{'text-align': 'right', 'width' : '200px'}"
        :contentStyle="{'width': '400px'}"
      >{{this.list.bidValidity}}</el-descriptions-item>
    </el-descriptions>
    <div
      style="
        background-color: #0065b3;
        color: #fff;
        font-size: 16px;
        padding: 6px 20px;
        margin:20px 0;
      "
    >
      &nbsp;&nbsp;经办人信息
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      :inline="true"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="经办人：" prop="operator">
            <el-input v-model="ruleForm.operator" placeholder="经办人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系电话：" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="联系电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form style="margin-top: 43px;margin-bottom:100px;">
      <el-form-item style="text-align: center;">
        <el-button style="background: #0065b3;border:0;color:#fff">返回</el-button>
        <el-button style="background: #0065b3;border:0;color:#fff" @click="choice('ruleForm')">下一步</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="营业执照"
      :visible.sync="dialogVisible"
      width="40%">
      <div style="width:100%">
        <img :src="this.src" alt="" style="width:100%">
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {pickManage, showFile} from "../apis/project/index"
export default {
  data() {
    return {
      rules:{
        operator: [
          { required: true, message: '请输入经办人', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
        ],
      },
      dialogVisible:false,
      list:{},
      showClo:false,
      ruleForm: {
        operator: "",
        phone: "",
        orderFee:null,
      },
      src:null,
    }
  },
  methods:{
    see(){
      this.dialogVisible=true;
      this.src=`/api/MakeOrderController/showFile?userId=${window.sessionStorage.getItem('userId')}&fileType=1`;
      // showFile().then((res)=>{
      //   console.log("Res营业执照",res);
      //   window.open(res)
      // })
    },
    choice(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({
            name:"choice",
            params:{
              key:this.ruleForm,
            }
          });
        }
      })
    },
    preview(){
      this.centerDialogVisible=true;
    },
    show(){
      this.isShow=!this.isShow;
    },
    png(){
      this.isPng=!this.isPng
    },
    preservation(){
      this.$message({
        message:"保存成功",
        type:"success",
      });
      window.sessionStorage.setItem('wangyin',"")
      this.$router.push('/pay')
    },
    getInfo(){
      pickManage().then((res)=>{
        console.log("res------------",res);
        this.list=res.data.data;
        this.ruleForm.orderFee=Number(res.data.data.guaFee);
      })
    },
  },
  created(){
    this.getInfo()
    // var myDate = new Date();
    // this.year=myDate.getFullYear();
    // this.month=myDate.getMonth();
    // this.month=this.month+1;
    // this.day=myDate.getDate();

  },
  components: {

  }
}
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  margin: 0 20px;
}
</style>
